import { Badge, Box, Button, Center, Flex, Heading, HStack, Image, Spacer, Stat, StatLabel, StatNumber, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { DataUtils, ImageSize, SiteData, TeamData, TeamResults } from "../clients/data-service";
import { BuildQuery, FilterState, FilterSummary, FilterTeams, GetPlayerFilterHighlightString } from "../utilities/TeamFiltering";
import { ImagePeopleListing } from "./ImagePeopleListing";
import NavButton from "./NavButton";
import PageTitle from "./PageTitle";

class TeamResultPager extends React.Component<{team: TeamData, filterData: FilterState, siteData: SiteData}> {
    render() {
        const team = this.props.team;
        const siteData = this.props.siteData;
        const filterState = this.props.filterData;
        const filteredData = FilterTeams(siteData, filterState);

        const teamIndex = filteredData.findIndex(t => t.id === team.id);
        const linkQuery = filterState ? "?" + BuildQuery(filterState) : "";

        const prevId = teamIndex === 0 ? null : filteredData.at(teamIndex -1)?.id;
        const nextId = teamIndex === filteredData.length - 1 ? null : filteredData.at(teamIndex +1)?.id;

        return(
        <>
        <Box bg={'gray.700'} px={4} py={2} >
            <Flex w='100%' alignItems={'center'} justifyContent={'space-between'}>
                <NavButton to={`/team/${prevId}${linkQuery}`} isDisabled={prevId == null} text="Prev"/>
                <HStack mx={1}>
                    <Text>{teamIndex+1} of {filteredData.length}: {FilterSummary(filterState, siteData)}</Text>
                    <NavButton to={`/teams${linkQuery}`} text="List"/>
                </HStack>
                <NavButton to={`/team/${nextId}${linkQuery}`} isDisabled={nextId == null} text="Next"/>
            </Flex>
        </Box>
           
        </>)
    }
}

export default class TeamDisplay extends React.Component<{team: TeamData, filterData: FilterState, siteData: SiteData, isAuthenticated: boolean}> {
    render() {
        const team = this.props.team;
        const siteData = this.props.siteData;

        const teamImage = DataUtils.BestTeamImageDescriptor(siteData, team);
        const displayResults = team.result != null;
        const badgeStyle = 'outline';

        const playerFilterString = GetPlayerFilterHighlightString(this.props.filterData, siteData);
        const playerFilter = playerFilterString ? [playerFilterString] : [];
        const maxContentWidth = window.innerHeight * 1.3;
        return(
        <>
            <TeamResultPager filterData={this.props.filterData} siteData={this.props.siteData} team={this.props.team}></TeamResultPager>
            {/* <PageTitle>{DataUtils.TeamName(team)}</PageTitle> */}
            <Center>
                <VStack w="fill" mx={{ base: 2, md: 20 }} mb={20} mt={10} maxW={maxContentWidth}>
                    <Flex w="100%" verticalAlign='bottom' mb={4}>
                        <Heading size={{ base: 'lg', md: '2xl' }}>{DataUtils.TeamName(team)}</Heading>
                        <Spacer/>
                        <Box textAlign='right'>
                            <VStack align='right'>
                                <Box>{team.result &&<Badge fontSize={{ base: '0.8em', md: '1em' }}  colorScheme='orange' variant={badgeStyle}>{DataUtils.LookupDisplay(TeamResults(), team.result!)}</Badge>}</Box>
                                <Box>{team.minor_premiers &&<Badge fontSize={{ base: '0.8em', md: '1em' }} ml={1}  colorScheme='orange' variant={badgeStyle}>Minor Premiers</Badge>}</Box>
                            </VStack>
                        </Box>
                    </Flex>
                    <Box >
                            {/* <Stat visibility={displayResults ? 'visible' : 'hidden'}>
                                <StatLabel>Season Result</StatLabel>
                                <StatNumber>{DataUtils.LookupDisplay(TeamResults(), team.result!)}</StatNumber>
                            </Stat> */}
                            {teamImage != null && (<>
                                <Image objectFit='cover' w="100%" mb={4}  borderRadius='lg' src={DataUtils.GetImageUrl(teamImage?.public_image ?? teamImage?.original_image, ImageSize.Full)} fallbackSrc={DataUtils.GetImageUrl(teamImage?.public_image ?? teamImage?.original_image, ImageSize.Small)}  />
                                {this.props.isAuthenticated && <Flex m={1}><Spacer/><NavButton to={`/annotate-image/${teamImage?.id}`} colorScheme="green" text="Annotate Image"/></Flex>}
                                <ImagePeopleListing descriptor={teamImage} playersToHighlight={playerFilter}/>
                            </>)}
                            
                    </Box>
                </VStack>
                
            </Center>
        </>)
    }
}
